import React from "react"
import PropTypes from "prop-types"
import styled from "styled-components"

const StyledCustomList = styled.ul`
  list-style: none;
  margin: 0;
  padding: 0;
  li {
    display: grid;
    grid-template-columns: 2.4rem 1fr;
    grid-column-gap: 0.6rem;
    padding: 0.25em 0;
    &:first-child {
      margin-top: 2rem;
    }
    svg {
    }
  }
`

function CustomList({ children, ...props }) {
  return <StyledCustomList {...props}>{children}</StyledCustomList>
}

export default CustomList

CustomList.defaultProps = {}
CustomList.propTypes = {
  children: PropTypes.node.isRequired,
}
